export var TextAreaTheme;
(function (TextAreaTheme) {
    TextAreaTheme["Box"] = "box";
    TextAreaTheme["Line"] = "line";
})(TextAreaTheme || (TextAreaTheme = {}));
//# sourceMappingURL=types.js.map